import SectionHeading from "@/components/base/SectionHeading";
import Tag from "@/components/base/Tag";
import { posts } from "@/mocks/posts";

export default function HotPosts() {
  const featured = posts[1];
  const secondary = posts.slice(0, 6).filter((item) => item.id !== featured.id);

  return (
    <section id="hot" className="mx-auto w-full max-w-container scroll-mt-24 px-4 md:px-6 py-16 md:py-20">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <SectionHeading
          eyebrow="Trending"
          title="热门爆料"
          desc="被讨论最多的线索，往往藏着最多值得深挖的细节。"
        />
        <a href="#feed" className="inline-flex items-center gap-1.5 font-label text-sm text-primary-700 hover:text-primary-600 cursor-pointer whitespace-nowrap">
          查看全部爆料
          <i className="ri-arrow-right-line text-base" aria-hidden="true" />
        </a>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
        <article className="group lg:col-span-7">
          <a href={`#post-${featured.id}`} className="block cursor-pointer">
            <div className="relative h-64 w-full overflow-hidden rounded-lg bg-background-200 md:h-[420px]">
              <img
                src={featured.cover}
                alt={`${featured.title} 的现场配图`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1.5 font-label text-xs font-medium text-background-50">
                <i className="ri-fire-line text-sm" aria-hidden="true" />
                本周最热
              </span>
            </div>
            <div className="mt-5">
              <div className="flex flex-wrap items-center gap-2">
                <Tag>{featured.category}</Tag>
                {featured.tags.map((tag) => (
                  <span key={tag} className="font-label text-xs text-foreground-500">
                    #{tag}
                  </span>
                ))}
              </div>
              <h3 className="mt-3 font-heading text-xl md:text-3xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                {featured.title}
              </h3>
              <p className="mt-3 line-clamp-3 text-sm md:text-base leading-relaxed text-foreground-600">
                {featured.excerpt}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-4 font-label text-xs md:text-sm text-foreground-500">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-user-3-line text-base" aria-hidden="true" />
                  {featured.author}
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-time-line text-base" aria-hidden="true" />
                  {featured.time}
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-chat-3-line text-base" aria-hidden="true" />
                  {featured.comments} 条讨论
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-thumb-up-line text-base" aria-hidden="true" />
                  {featured.likes}
                </span>
              </div>
            </div>
          </a>
        </article>

        <div className="flex flex-col divide-y divide-background-200 lg:col-span-5">
          {secondary.map((post) => (
            <article key={post.id} className="group py-4 first:pt-0 last:pb-0">
              <a href={`#post-${post.id}`} className="flex cursor-pointer items-start gap-4">
                <div className="h-20 w-24 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-24 md:w-32">
                  <img
                    src={post.cover}
                    alt={`${post.title} 的配图`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <span className="font-label text-xs text-primary-600">{post.category}</span>
                  <h3 className="mt-1 line-clamp-2 font-heading text-base md:text-lg font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
                    {post.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-3 font-label text-xs text-foreground-500">
                    <span>{post.author}</span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-chat-3-line" aria-hidden="true" />
                      {post.comments}
                    </span>
                  </div>
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}